import React from "react";
import PropTypes from "prop-types";
import clsx from "classnames";
import { enums } from "../enums";
import { Loader } from "components";
import "./style.scss";

const Button = ({
  label,
  disabled = false,
  variant,
  startIcon,
  endIcon,
  size,
  fullWidth,
  loading,
  loadingText,
  type,
  className,
  style,
  ...rest
}) => {
  const baseClass = "pm-btn";

  const fullContainerWidth = fullWidth ? "full-width" : "";

  const btnDisabled = disabled ? "--btn-disabled" : "";

  const btnLoading = loading ? "--btn-loading" : "";

  const buttonClasses = clsx(
    className,
    `${baseClass}`,
    `${baseClass}--${size}`,
    `${baseClass}--${variant}${btnDisabled}${btnLoading}`,
    `${baseClass}--${fullContainerWidth}`
  );

  return (
    <button
      type={loading ? "button" : type}
      className={buttonClasses}
      disabled={disabled}
      style={style}
      {...rest}
    >
      {loading ? (
        <Loader color="#FFFFFF" height={20} width={2} margin={2} />
      ) : (
        <>
          {startIcon} &nbsp; {label} &nbsp; {endIcon}
        </>
      )}
    </button>
  );
};

Button.defaultProps = {
  label: "Button",
  variant: "primary",
  size: "md",
  type: "button",
};

Button.propTypes = {
  type: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  label: PropTypes.string,
  endIcon: PropTypes.node,
  startIcon: PropTypes.node,
  variant: PropTypes.oneOf(enums.buttonVariants),
  size: PropTypes.oneOf(enums.componentSizes),
};

export default Button;
